import { useLiveQuery } from 'dexie-react-hooks';
import { Link, useParams } from 'react-router-dom';
import { db } from '../db/db';

export function JobInfoPage() {
  const { jobId } = useParams<{ jobId: string }>();
  const job = useLiveQuery(() => (jobId ? db.jobs.get(jobId) : undefined), [jobId]);
  const groups = useLiveQuery(() => (jobId ? db.groups.where('jobId').equals(jobId).count() : 0), [jobId]);
  const subjects = useLiveQuery(() => (jobId ? db.subjects.where('jobId').equals(jobId).count() : 0), [jobId]);

  if (!job) return <div className="screen screen--centered">Loading…</div>;

  return (
    <div className="screen">
      <header className="app-header">
        <Link to={`/jobs/${jobId}`} className="back-link">
          ← {job.name}
        </Link>
        <h1>Job info</h1>
      </header>

      <dl className="info-list">
        <dt>School / nursery</dt>
        <dd>{job.schoolLabel || '—'}</dd>
        <dt>Shoot date</dt>
        <dd>{job.shootDate}</dd>
        <dt>Source</dt>
        <dd>{job.sourceType === 'local-upload' ? 'Local file upload' : 'Dropbox link'}</dd>
        <dt>Parser</dt>
        <dd>
          {job.parserAdapterId} v{job.parserAdapterVersion}
        </dd>
        <dt>Status</dt>
        <dd>{job.importStatus}</dd>
        <dt>Groups</dt>
        <dd>{groups}</dd>
        <dt>Subjects</dt>
        <dd>
          {job.completedSubjects} of {subjects} photographed
        </dd>
        <dt>Available offline</dt>
        <dd>{job.availableOffline ? 'Yes' : 'No'}</dd>
        <dt>Created</dt>
        <dd>{new Date(job.createdAt).toLocaleString()}</dd>
        <dt>Last updated</dt>
        <dd>{new Date(job.updatedAt).toLocaleString()}</dd>
      </dl>
    </div>
  );
}
